import Form from "../../form/Form";
import { notice } from "JS/utils/notice";

export default class SignupTripForm {

    /**
     * @type {HTMLFormElement}
     */
    formElement;

    /**
     * @type {HTMLFormElement}
     */
    afterSubmitElement;

    /**
     * @type {Form}
     */
    form;

    offers = [];

    /**
     * @param {HTMLFormElement} form 
     */
    constructor(form) {
        if (!form) {
            return form;
        }

        this.formElement = form;
        this.form = new Form(this.formElement);
        this.submitButton = this.formElement.querySelector('[type="submit"]');
        this.afterSubmitElement = document.querySelector('.signup-trip__after-submit-text');

        this.findOffers();
        this.addListeners();
    }

    addListeners() {
        this.form.on('change', (data) => {
            this.setOfferPrice(data);
        });

        this.form.on('submit', (data) => {
            this.process(data);
        });
    }

    findOffers() {
        const scriptEl = this.formElement.querySelector('[data-offers-data]');

        if (!scriptEl) {
            return;
        }

        this.offers = JSON.parse(scriptEl.textContent);
        scriptEl.remove();
    }

    setOfferPrice(data) {
        const offer = this.offers.find(el => el.getcourse_offer_id === data.offer_id);
        const priceEl = this.formElement.querySelector('[data-price-place]');

        if (!priceEl) {
            return;
        }

        if (!offer) {
            priceEl.innerHTML = '';
            return;
        }

        const price = `${new Intl.NumberFormat("ru-RU").format(offer.price)}₽`;
        priceEl.innerHTML = price;
    }

    process(data) {
        const { _trip_nonce, user_accept, _wp_http_referer, ...order } = data;
        const formData = new FormData();

        formData.append('nonce', _trip_nonce);
        formData.append('action', 'apply_getcource_trip');
        formData.append('data', JSON.stringify(order));

        if (this.submitButton) {
            this.submitButton.classList.add('processing');
        }

        fetch(backendData.ajaxUrl, {
            method: 'POST',
            body: formData,
        })
            .then((resp) => resp.json())
            .then((response) => {
                if (!response.success) {
                    this.onError(response.data.message);
                    return
                }

                const { data } = response;

                if (data.result_deal.payment_link) {
                    if (this.submitButton.getAttribute('data-pay-redirect')) {
                        notice('Перенаправляем на страницу оплаты');
                    
                        setTimeout(() => {
                            window.location.href = data.result_deal.payment_link;
                        }, 500);
                    } else {
                        this.formElement.classList.add('hide');
                        setTimeout(() => {
                            this.formElement.remove();
                            this.afterSubmitElement.classList.add('show');
                        }, 400);
                    }
                }
            })
            .catch((error) => {
                this.onError(error);
            })
            .finally(() => {
                if (this.submitButton) {
                    this.submitButton.classList.remove('processing');
                }
            });
    }

    onError(error) {
        notice(error, 'error');
    }
}
